module.exports = __webpack_public_path__ + "../resources/img/ic_sns_linkedin_gray.154f573f.svg";